import { useContext, useEffect } from 'react'

import { SalesforceChatContext } from '../contexts/SalesforceChatContext'

export function useDisableSalesforceChat(): void {
  const context = useContext(SalesforceChatContext)

  if (context === undefined) {
    throw new Error(`useDisableSalesforceChat must be used within a SalesforceChatProvider`)
  }

  useEffect(() => {
    context.hideChatButton()

    return () => {
      context.showChatButton()
    }
  }, [context])
}
